import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppNavRouter from './components/AppNavRouter.js';
import { Provider } from 'react-redux';
import store from './store';
import './firebase.js';
import { OnlineProvider } from './context/OnlineContext';
import { UpdateProvider } from './context/UpdateContext';
import AnalyticsProvider from './components/analytics/AnalyticsProvider';
import './db';


// Analytics wrapper component
function AppWithAnalytics() {
  return (
    <Provider store={store}>
      <OnlineProvider>
        <UpdateProvider>
          <AnalyticsProvider>
            <React.StrictMode>
              <AppNavRouter />
            </React.StrictMode>
          </AnalyticsProvider>
        </UpdateProvider>
      </OnlineProvider>
    </Provider>
  );
}

// Initialize the root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app
root.render(<AppWithAnalytics />);


// Report web vitals
reportWebVitals();
